




























































import { Button, MDInput } from "@micad/vue-components";
import { computed, defineComponent, reactive } from "@vue/composition-api";
import router from "@/router";
import {
  sendPasswordResetEmail,
  SendPasswordResetEmailRequest,
} from "@/data/repos/requestPasswordResetEmail";

export default defineComponent({
  components: {
    Button,
    MDInput,
  },
  props: {
    pUserName: String,
  },
  setup(p) {
    const query = router.currentRoute.query;
    function backToPreLogin() {
      router.back();
    }
    const state = reactive({
      userName: String(router.currentRoute.query.userName || ""),
      sent: false,
      backToPreLogin,
      submit,
      isMobileApp: computed(() =>
        String(router.currentRoute.query.returnUrl).startsWith("MicadSFM")
      ),
    });
    async function submit() {
      const req = {
        userName: state.userName,
        clientKey: query.clientKey,
        returnUrl: query.returnUrl,
        originalUrl: query.originalUrl,
      } as SendPasswordResetEmailRequest;
      const resp = await sendPasswordResetEmail(req);
      if (resp.ok) {
        state.sent = true;
      }
    }
    return state;
  },
});
